<template>

  <div class="mt-6 ml-4 flex space-between space-x-4 justify-between m-2 mr-4 flex-end">
    <div>
      <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
        ROI Insights
      </h1>
      <h1 class="text text-gray-900 dark:text-gray-200" style="font-size: 16px;">
        Increase the ROI from your contact centers.
      </h1>
    </div>
  </div>

  <div
    class="overflow-x-auto text-align ml-3 mt-6 card shadow bg-white dark:bg-gray-800 w-full rounded-md p-3 border dark:border-gray-700 flex"
    style="border-radius: 10px; width:98%;height: 75vh;font-size: 16px;">
    
    <div v-if="roiInsights!=null" v-for="currentInsight in roiInsights.insights">
      <div role="alert" class="alert mb-4" :class="[(currentInsight.type.includes('warning') === true) ? 'alert-warning' : '',textDirectionClass('היי')]">
        <svg v-if="currentInsight.type.includes('warning') != false" xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 shrink-0 stroke-current" fill="none" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <svg v-if="currentInsight.type.includes('info') === true" xmlns="http://www.w3.org/2000/svg" fill="none"
          viewBox="0 0 24 24" class="stroke-info h-6 w-6 shrink-0">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <div v-html="sanitizeHtml(currentInsight.htmlContent)"></div>
      </div>
    </div>
    <div v-else class="flex justify-center items-center w-full h-full">
      <span class="loading loading-infinity loading-lg" style="width:116px;color:#4f46e5"></span>
    </div>
  </div>







</template>
<style src="@vueform/multiselect/themes/default.css"></style>
<style>
table {
  font-family: "Heebo", sans-serif !important;
}
</style>
<script setup>
import { ref, onMounted } from 'vue';
import EasyDataTable from "vue3-easy-data-table";
import Multiselect from '@vueform/multiselect'
import { SelectPageList } from 'v-selectpage'
import { cond } from 'lodash';
import { sanitizeHtml } from '@/shared/utils/sanitizeHtml';


const searchFields = ["contactCenterID", "contactCenterName"];
const searchValue = ref("");

const roiInsights = ref(null);

onMounted(function(){
  fetchROIInsights();
});

async function fetchROIInsights(){
  setTimeout(() => { 
    roiInsights.value= {
  "insights":[
    {
      "type":"warning",
      "htmlContent":`
        <span>לאחרונה
        <div class="font-bold inline-block">15%</div>
        מהפונים למוקד השירות "מרפאת בני ברק"
        <div class="font-bold inline-block">ביקשו לעזוב את השירות</div>
        עקב תלונות על רופא גבר לרופאי הנשים, עקב היותם דתיים.
      </span>
      `
    },
    {
      "type":"info",
      "htmlContent":`
        <span>נציגי השירות מבזבזים 
        <div class="font-bold inline-block">25%</div>
        אחוז מהשיחה
        <div class="font-bold inline-block">בממוצע 1.5 דקות</div>
       לברר מידע על הנושאים הבאים:
       
        ממליצים להוסיף מידע לשירות Agent Assistance וכך הנציגים יוכלו לשאול בצאט את הAI ויקבלו תשובה במהירות ובקלות
      </span>
      `,
      "buttonSettings":{
        "buttonText":"Agent Assistance",
        "action":"goToAgentAssistance"
      }
    }
  ]
 }

   }, 500);
  
}

const headers = [
  { text: "ID", value: "contactCenterID", sortable: true },
  { text: "Name", value: "contactCenterName", sortable: true },
  { text: "Teams", value: "contactCenterTeams" },
  { text: "Options", value: "options" }

];





let contactCentersDebug = ref([
  {
    "contactCenterGuid": "0a1a65c7-0db4-467b-9818-71d06f019856",
    "contactCenterID": "1",
    "contactCenterName": "מוקד שירות ראשי",
    "contactCenterTeams": [{
      "teamName": "צוות שכר"
    },
    {
      "teamName": "צוות תמיכה"
    }]
  },
  {
    "contactCenterGuid": "0a1a65c7-0db4-467b-9818-71d06f019856",
    "contactCenterID": "2",
    "contactCenterName": "מוקד שירות לתמיכה באייפון",
    "contactCenterTeams": [{
      "teamName": "צוות שכר"
    },
    {
      "teamName": "צוות תמיכה"
    }]
  }

]);



onMounted(() => {
  loadStyle(`
.vue3-easy-data-table {
  height: 95%;
}
.sp-trigger-container.sp-opened{
  box-shadow:none;
}
  .dp__main{
    width:262px;
    height:100%;
  }
    .sp-trigger-container .sp-trigger.sp-chips{
    max-height: 1.8rem;
    overflow: auto;
    }
    .sp-trigger-container{
      height:3rem;
    }
    .dp__main input {
     padding-left:17%;
    border-color: #dadcdf;
    flex-shrink: 1;
    appearance: none;
    height: 3rem;
    width:260px;
    font-size: 1rem;
    line-height: 2;
    line-height: 1.5rem;
    border-radius: var(--rounded-btn, .5rem);
    border-width: 1px;
    
    --tw-bg-opacity: 1;
    background-color: var(--fallback-b1,oklch(var(--b1)/var(--tw-bg-opacity)));
    }

    .multiselect{
      height:3rem;
      width: 180px;
      margin-right:1%;
    }
  `);


})
function loadStyle(cssString) {

  const style = document.createElement('style');


  style.type = 'text/css';


  if (style.styleSheet != null) {
    style.styleSheet.cssText = cssString;
  } else {

    style.appendChild(document.createTextNode(cssString));
  }


  document.head.appendChild(style);
}
function detectTextDirection(text) {
  const rtlChars = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/;
  return rtlChars.test(text) === true ? 'rtl' : 'ltr';
}
function textDirectionClass(text) {
  return detectTextDirection(text) === 'rtl' ? 'text-rtl heebo-text' : 'text-ltr';
}



</script>
